var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kwq8vn9ufa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.017 19.3c-.04-.033-3.017-2.178-3.834-2.024-.39.069-.613.335-1.06.867-.073.087-.245.293-.38.439a6.85 6.85 0 0 1-4.322-4.322c.147-.135.353-.308.441-.382.53-.445.796-.668.865-1.059.142-.81-2.002-3.807-2.024-3.834a1.144 1.144 0 0 0-.853-.485c-.869 0-3.35 3.219-3.35 3.76 0 .032.046 3.234 3.994 7.25 4.012 3.944 7.214 3.99 7.245 3.99.543 0 3.761-2.481 3.761-3.35a1.141 1.141 0 0 0-.483-.85z",
    fill: "#7CB6E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kwq8vn9ufa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phoneWhite.b416207657cf1e6e4a8a007ea3028890.svg";
export { ForwardRef as ReactComponent };